import React from 'react';
import { FormGroup, Label, Form, Input, Container , Button} from 'reactstrap';

const Contact=()=>{
    return(
        <div >
            <h2 style={{padding:'30px'}}>For any Querries Contact Us:</h2>
            <Form style={{paddingLeft:"30px"}}>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" id="name" />
                </FormGroup>

                <FormGroup>
                    <Label for='email'>Email</Label>
                    <Input type="email" id='email' />
                </FormGroup>

                <FormGroup>
                    <Label for='phoneNo'>Phone Number</Label>
                    <Input type="numbers" id='phoneNo' />
                </FormGroup>

                <FormGroup>
                    <Label for='query'>Please Enter your Query</Label>
                    <Input type="textarea" id='query' style={{height:100}} />
                </FormGroup>

            </Form>

            <Container style={{textAlign:"center"}}>
                <Button color= "warning">Submit</Button>
                <Button color="danger ms-3" >Clear</Button>
            </Container>
        </div>
    );
}
export default Contact;